import { useEffect, useRef, useState } from "react";
import Modal from "@/components/Modal";
import { KeyRound } from "lucide-react";

// Saisie du code unique communiqué par le propriétaire (appel / WhatsApp). Jamais le PIN personnel.
export default function AuthCodeModal({ req, onSubmit, onCancel }) {
  const [code, setCode] = useState("");
  const ref = useRef(null);
  useEffect(() => { setCode(""); if (req) setTimeout(() => ref.current?.focus(), 50); }, [req]);
  if (!req) return null;
  return (
    <Modal open onClose={onCancel} title="Autorisation requise" testId="auth-code-modal" zClass="z-[70]"
      footer={<>
        <button className="btn-outline" onClick={onCancel} data-testid="auth-code-cancel">Annuler</button>
        <button className="btn-primary" disabled={code.trim().length < 6} onClick={() => onSubmit(code.trim())} data-testid="auth-code-submit">Valider avec le code</button>
      </>}>
      <div className="space-y-3">
        <div className="flex items-start gap-3 p-3 rounded-xl bg-[#FFFBEB] border border-[#FDE68A] text-[#92400E] text-sm">
          <KeyRound className="w-5 h-5 shrink-0 mt-0.5" />
          <div><div className="font-semibold" data-testid="auth-code-action">{req.label}</div><div className="text-xs mt-0.5">Cette action est protégée dans votre boutique. Demandez un code unique au propriétaire (appel ou WhatsApp) : valable 5 minutes, une seule fois.</div></div>
        </div>
        {req.message && req.code !== "AUTH_CODE_REQUIRED" && <p className="text-sm text-[#B91C1C] font-medium" data-testid="auth-code-error">{req.message}</p>}
        <input ref={ref} inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          onKeyDown={(e) => { if (e.key === "Enter" && code.trim().length >= 6) onSubmit(code.trim()); }}
          className="inp text-center text-2xl font-bold tracking-[0.5em]" placeholder="••••••" data-testid="auth-code-input" />
      </div>
    </Modal>
  );
}

// Hook : expose ask() compatible withAuthCode + le modal à rendre.
export function useAuthCodePrompt() {
  const [req, setReq] = useState(null);
  const resolver = useRef(null);
  const ask = (detail) => new Promise((resolve) => { resolver.current = resolve; setReq(detail); });
  const done = (val) => { setReq(null); resolver.current?.(val); resolver.current = null; };
  const modal = <AuthCodeModal req={req} onSubmit={(c) => done(c)} onCancel={() => done(null)} />;
  return { ask, modal, setReq };
}
